<template>
    <div class="top">
        <div class="line"></div>
        <el-popover
                ref="popover5"
                placement="bottom"
                width="160"
                trigger="click"
                v-model="visible2">
            <p style="text-align: center;margin-bottom: 10px;">确定退出登录吗？</p>
            <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="visible2 = false"  class="showBtn">取消</el-button>
                <el-button type="primary" size="mini" @click="loginout()"  class="showBtn">确定</el-button>
            </div>
        </el-popover>
        <el-menu class="el-menu-demo" mode="horizontal" @select="handleSelect" style="background-color: #fff;">
            <router-link class="fb-touch" :to="{name:'index'}">
                <div class="na-left" >
                    <img src="../../assets/LOGO.png" style="height: 40px; margin-left: -65px;">
                    <!--<span class="name">拍贝热点云平台 </span>-->
                </div>
            </router-link>
            <div class="na-right">
                <el-menu-item index="1" v-if="is_navbar==true"><img class="nav-user" src="../../assets/user_logo.png"></el-menu-item>

                <el-submenu index="1" v-if="is_navbar==false">
                    <template slot="title"><img class="nav-user" src="../../assets/user_logo.png"></template>
                    <el-menu-item index="2">{{name}}</el-menu-item>
                    <el-menu-item index="1-1" @click="dialogFormVisible = true">修改密码</el-menu-item>
                    <el-menu-item index="1-2" v-popover:popover5>退出登录</el-menu-item>
                </el-submenu>


            </div>
        </el-menu>
        <el-dialog title="修改密码" :visible.sync="dialogFormVisible" :modal-append-to-body="false">
            <el-form  :model="pwdForm" :rules="pwdrules" ref="pwdForm" class="demo-ruleForm">

                <el-form-item prop="username">
                    <el-input  v-model="pwdForm.username" :disabled="true"></el-input>
                </el-form-item>

                <el-form-item prop="oldpassword">
                    <el-input type="password" v-model="pwdForm.oldpassword" placeholder="请输入原密码"></el-input>
                </el-form-item>

                <el-form-item prop="newpassword">
                    <el-input type="password" v-model="pwdForm.newpassword" placeholder="请输入新密码"></el-input>
                </el-form-item>

                <el-form-item prop="newpasswordr">
                    <el-input type="password" v-model="pwdForm.newpasswordr" placeholder="请再次输入新密码"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false" class="showBtn">取 消</el-button>
                <el-button type="primary" @click="submitForm('pwdForm')" class="showBtn" >确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import secret from '../../assets/js/jsencrypt.min'
   var encrypt = new secret.JSEncrypt();
    export default {
        mounted () {
            const that = this
            window.onresize = () => {
                return (() => {
                    window.screenWidth = document.body.clientWidth
                    that.screenWidth = window.screenWidth
                })()
            }
        },
        data(){
            var validateCheckpass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入新密码！'));
                } else {
                    if (this.pwdForm.newpassword !== value) {
                        callback(new Error('两次输入密码不一致！'));
                    }
                    if (this.pwdForm.newpassword.indexOf(" ") == -1) {
                        callback();
                    }else {
                        callback(new Error('密码不能包含空格！'));
                    }
                    callback();
                }
            };
            return{
                url:this.requetHost+"/sys/user/changepwd",
                disabled:false,
                screenWidth: document.body.clientWidth,
                visible2: false,
                dialogFormVisible:false,
                is_navbar:true,
                pwdForm:{
                    username:this.getcookie('username'),
                    newpassword:'',
                    newpasswordr:'',
                    oldpassword:''
                },
                pwdrules: {
                    newpassword: [
                        { required: true, message: '请输入新密码', trigger: 'blur' },
                        { validator: this.validatorSpace, trigger: 'blur' },
                        /*{ validator: this.validatorCharmap, trigger: 'blur' },*/
                        { min: 6, max: 12, message: '长度在 6 到 12 个字符', trigger: 'blur' },
                        { validator: validateCheckpass, trigger: 'blur' },
                    ],
                    newpasswordr: [
                        { required: true, message: '请再次输入新密码', trigger: 'blur' },
                        { validator: this.validatorSpace, trigger: 'blur' },
                        /*{ validator: this.validatorCharmap, trigger: 'blur' },*/
                        { min: 6, max: 12, message: '长度在 6 到 12 个字符', trigger: 'blur' },
                        { validator: validateCheckpass, trigger: 'blur' },
                    ],
                    oldpassword: [
                        { required: true, message: '请输入原密码', trigger: 'blur' },
                    ]
                },
            }
        },
        computed: {

            isActive () {
                return this.$store.state.isActive
            },
            isClose(){
                return this.$store.state.isClose
            },
            name() {
                return this.getcookie('username')
            },

        },
        created(){
            //调用查询函

           var wclogin=this.getcookie("wcLogin")
            if(wclogin==='1'){
               this.is_navbar=true;
            }else{
                this.is_navbar=false;
            }
            console.log(this.is_navbar);
        },
        methods:{
            select(){
                console.log("nduifhwei");
            },
            onoroff(isActive){
                if(isActive===true){
                    this.$store.commit('CHANGE_MENU',false)
                    this.$store.commit('IS_CLOSE',true)
                }
                else{
                    this.$store.commit('CHANGE_MENU',true)
                    this.$store.commit('IS_CLOSE',false)
                }
            },
            handleSelect(key, keyPath) {
                console.log(key, keyPath);
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {

//                        let encrypt =new this.$jsEncrypt.jsEncrypt();
//                        var encrypt =new encrypt.JSEncrypt();
                        var oldpass ="";
                        var newpass ="";
                        encrypt.setPublicKey(this.publickey);
                        oldpass= encrypt.encrypt(this.pwdForm.oldpassword);
                        newpass= encrypt.encrypt(this.pwdForm.newpassword);
                        var params={username:this.pwdForm.username,newpassword:newpass,oldpassword:oldpass}
                        this.$http.post(this.url,params).then((response)=>{
                            var data=response.body;
                            debugger;
                            if(data.status=='200'){
                                this.$message({showClose: true,message: '保存成功',type: 'success'});
                                this.$router.push({name:"login"})
                            }else if(data.status=='504'){
                                this.$message({showClose: true,message: '原密码错误',type: 'error'});
                            }else if(data.status=='503'){
                                this.$message({showClose: true,message: '新密码与旧密码不能相同',type: 'error'});
                            }else{
                                this.$message({showClose: true,message: '保存失败',type: 'error'});
                            }
                        },function(response){
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'

                            });
                        })
                    }else{
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            loginout() {
                this.$http.get(this.requetHost+'/sys/user/loginout')
                    .then(response => {
                    if (response.status === 200){
                        console.log(this.getcookie('username'));
                        if (response.body.msg == this.getcookie('username')) {
                            //缓存用户Js
                            this.savecookie("button", null);
                            /*this.$store.commit('CHANGE_USERNAME',"");*/
                            /*this.savecookie("user_token",  response.body.user_token, 0);*/
                            this.$message.success('退出成功!');
                        }
                        this.$router.push("/login");
                     }
                     },function(response){
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'

                            });
                });
            }
        }

    }
</script>
<style>
    /*@import url('../../assets/css/bootstrap.min.css');*/
    /*head 样式*/
    .top{
        margin: 0;
        max-width: 100%;
        height: 60px;
        background-color: #eef1f6;
        /*box-shadow: 0px 5px 0px #e0e0e0;*/
        /*border:1px  solid red;*/
        vertical-align: middle;
        /*padding-bottom: 50px;*/
        position:fixed;
        height:60px;
        width:100%;
        z-index:1056;
    }

    .name{
        font-size: 18px;
        font-weight: bold;
        margin-left: 2px;
    }

    .nav-login{
        float: right;
        padding:5px 5px 5px 5px;
        line-height: 20px;
        margin-top: -5px;
        text-decoration: none;
        /*border:1px  solid fuchsia;*/
    }
    .uname{
        vertical-align: middle;
        margin-left: 0px;
        border: 0px;
        background-color: transparent;
    }

    .na-right{
        /*border:1px solid red;*/
        margin-right: -20px;
        padding-left: 60px;
        text-align: center;
        float: right;
        width: 300px;
        height: 60px;
        /* border:1px  solid blue;*/
    }
    .nav-user{
        width: 35px;
        border-radius: 50%;
        vertical-align:middle;
    }
    /*屏幕12寸以上时*/
    @media screen and (min-width: 800px){
        /*隐藏*/
        .na-min-left{display:none}
        /*导航样式*/
        .na-left{
            display:block;
            padding-top: 10px;
            padding-bottom: 10px;
            height: 60px;
            width: 220px;
            float: left;
            text-align: center;

        }




    }


    /*屏幕 12寸以下时*/
    @media screen and (max-width: 799px){
        /*隐藏*/
        .na-left{display:none}
        .na-min-left{
            display:block;
            position:fixed;
            left:10px;
            top:10px;
        }
        .icon{
            margin-top: -13px;
            margin-left: 10px;
            padding:22px 5px 18px 5px;
            float: left;
            /*border:1px  solid fuchsia;*/
            height: 60px;
            vertical-align: middle;
        }
    }

    .no{
        overflow: hidden;
        width: 0%;

    }

    /*.h{*/
    /*display: none;*/
    /*}*/


    .big{
        width: 100%;
    }
    @import "../../assets/css/button.css";
</style>


// WEBPACK FOOTER //
// Navbar.vue?95ca38ce